if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span') || this.submitButton;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Connect the sticky button to submit this form if it's located outside
        // Connect the sticky button to submit this form if it's located outside
        document.addEventListener('click', (e) => {
            const stickyBtn = e.target.closest('.sticky-product-bar__add');

            if (stickyBtn && stickyBtn.getAttribute('form') === this.form?.id) {
              const isComplete = this.isVariantSelectionComplete;

              if (!isComplete) {
                e.preventDefault();
                e.stopPropagation();

                const trigger = document.querySelector('.mac-size-trigger');

                if (trigger) {
                  trigger.click();
                }

                return;
              }

              if (
                this.submitButton &&
                !this.submitButton.disabled &&
                this.submitButton.getAttribute('aria-disabled') !== 'true'
              ) {
                this.form.requestSubmit(stickyBtn);
              }
            }
          }, true);
      }

      // Helper to return BOTH the main submit button and the sticky bar button
      get allSubmitButtons() {
        return Array.from(
          document.querySelectorAll(`.product-form__submit, .sticky-product-bar__add, [form="${this.form?.id}"][type="submit"]`)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Put BOTH buttons into the loading state
        this.allSubmitButtons.forEach((btn) => {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('loading');
        });

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.allSubmitButtons.forEach((btn) => {
                btn.setAttribute('aria-disabled', 'true');
                const span = btn.querySelector('span') || btn;
                span.classList.add('hidden');
              });

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Remove loading state on BOTH buttons
            this.allSubmitButtons.forEach((btn) => {
              btn.classList.remove('loading');
              if (!this.error) btn.removeAttribute('aria-disabled');
            });

            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get isVariantSelectionComplete() {
        const variantSelects = document.querySelector('variant-selects');

        if (variantSelects && typeof variantSelects.hasBothSizesSelected !== 'undefined') {
          return variantSelects.hasBothSizesSelected;
        }

        return true;
      }

      toggleSubmitButton(disable = true, text) {
        const isComplete = this.isVariantSelectionComplete;

        this.allSubmitButtons.forEach((btn) => {
          const btnText = btn.querySelector('span') || btn;

          // Required variant selection is NOT complete
          if (!isComplete) {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btnText.textContent = 'Größe auswählen';
            return;
          }

          // All required variants are selected.
          // Let Shopify handle ADD TO CART / SOLD OUT.
          if (disable) {
            btn.setAttribute('disabled', 'disabled');
            btn.setAttribute('aria-disabled', 'true');

            if (text) {
              btnText.textContent = text;
            }
          } else {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btnText.textContent =
              window.variantStrings?.addToCart || 'In den Warenkorb legen';
          }
        });
      }

      get isVariantSelectionComplete() {
        const hasSizeOption = Boolean(
          document.querySelector(
            '.mac-size-panel [data-option-name="Size"], ' +
            'variant-selects [data-option-name="Size"], ' +
            '[data-option-name="Size"]'
          )
        );

        const hasLengthOption = Boolean(
          document.querySelector(
            '.mac-size-panel [data-option-name="Second size"], ' +
            '.mac-size-panel [data-option-name="Länge"], ' +
            'variant-selects [data-option-name="Second size"], ' +
            'variant-selects [data-option-name="Länge"], ' +
            '[data-option-name="Second size"], ' +
            '[data-option-name="Länge"]'
          )
        );

        const sizeSelected = Boolean(
          document.querySelector(
            '.mac-size-panel [data-option-name="Size"] input:checked, ' +
            'variant-selects [data-option-name="Size"] input:checked, ' +
            'input[name^="Size-2"]:checked'
          )
        );

        const lengthSelected = Boolean(
          document.querySelector(
            '.mac-size-panel [data-option-name="Second size"] input:checked, ' +
            '.mac-size-panel [data-option-name="Länge"] input:checked, ' +
            'variant-selects [data-option-name="Second size"] input:checked, ' +
            'variant-selects [data-option-name="Länge"] input:checked, ' +
            'input[name^="Second size-3"]:checked, ' +
            'input[name*="Länge"]:checked, ' +
            'input[name*="length"]:checked'
          )
        );

        return (
          (!hasSizeOption || sizeSelected) &&
          (!hasLengthOption || lengthSelected)
        );
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}